export var BeeModes;
(function (BeeModes) {
  BeeModes["FULL"] = "full";
  BeeModes["LIGHT"] = "light";
  BeeModes["ULTRA_LIGHT"] = "ultra-light";
  BeeModes["DEV"] = "dev";
})(BeeModes || (BeeModes = {}));
export function toBeeMode(value) {
  switch (value) {
    case 'full':
      return BeeModes.FULL;
    case 'light':
      return BeeModes.LIGHT;
    case 'ultra-light':
      return BeeModes.ULTRA_LIGHT;
    case 'dev':
      return BeeModes.DEV;
    default:
      throw new Error(`Unknown Bee mode: ${value}`);
  }
}